module.exports = __webpack_public_path__ + "img/system_2.87382005.jpg";